// Analytics event placeholders. Consent-gated: nothing fires before consent is granted.
// No personal or special-category data is ever passed to analytics.

const ALLOWED_EVENTS = new Set([
  "customer_app_clicked",
  "digital_postbox_clicked",
  "phone_number_clicked",
  "email_address_clicked",
  "complaints_policy_clicked",
  "regulatory_document_clicked",
  "faq_opened",
  "contact_form_started",
  "contact_form_submitted",
  "external_regulator_link_clicked",
]);

export function hasAnalyticsConsent() {
  try {
    return localStorage.getItem("fj_cookie_consent") === "accepted";
  } catch {
    return false;
  }
}

// Only whitelisted, non-identifying metadata is permitted.
export function track(event, meta = {}) {
  if (!ALLOWED_EVENTS.has(event)) return;
  if (!hasAnalyticsConsent()) return;

  const safeMeta = {};
  if (typeof meta.label === "string") safeMeta.label = meta.label;
  if (typeof meta.location === "string") safeMeta.location = meta.location;

  // Placeholder: push to a dataLayer if a consented analytics tool is later added.
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...safeMeta });

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug("[analytics]", event, safeMeta);
  }
}
